import { utcToZonedTime } from 'date-fns-tz'

export const isChristmas = () => {
  const now = new Date()
  const month = now.getMonth()
  const day = now.getDate()

  // 11 is December, 26 is Boxing Day
  return month == 11 && day < 26
}

export const createZonedDate = (date?: Date | string): Date => {
  const timeZone = 'Australia/Sydney'
  if (date) {
    const zonedDate = typeof date === 'string' ? new Date(date) : date
    return utcToZonedTime(zonedDate, timeZone)
  } else {
    return utcToZonedTime(new Date(), timeZone)
  }
}

export const isExpired = (expiryDate: string): boolean => {
  const now = new Date()
  const expiry = new Date(expiryDate)
  return expiry <= now
}
